import { createApi } from '@reduxjs/toolkit/query/react'
import { rtkBaseQuery } from 'Src/api'

export const signupApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'signupApi',
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/signup',
          method: 'POST',
          body: payload
        }
      }
    }),
    checkEmailSignup: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/check-signup',
          method: 'POST',
          body: payload
        }
      }
    })
  })
})

export const { useSignupMutation, useCheckEmailSignupMutation } = signupApi

export default signupApi
